export default {"src":"/_next/static/image/public/images/flags/flag_971.534fc93da5a7648501dc124170d62fd2.svg","height":16,"width":24};